import { H6 } from "@sellar-io/components";
import React from "react";
import { twMerge } from "tailwind-merge";
export const Breadcrumbs = <
  T extends readonly string[],
  K extends keyof T,
>(props: {
  crumbs: T;
  selectedCrumb: T[K];
}): React.ReactElement => {
  return (
    <div className="flex gap-1 text-gray-400">
      {props.crumbs.map((item, i) => (
        <div className="inline-flex gap-1 font-bold" key={item}>
          <H6
            key={item}
            className={twMerge(item === props.selectedCrumb && "text-gray-900")}
          >
            {item}
          </H6>
          {i < props.crumbs.length - 1 && <p>&gt;</p>}
        </div>
      ))}
    </div>
  );
};
